import { useSelector } from 'react-redux';
import React, { ComponentProps } from 'react';
import * as R from 'ramda';

import { PosPlugin } from 'plugins/plugin';
import { getVatRateByID } from 'reducers/vatRatesDB';

import styles from './styles.module.scss';

type UICustomTableBillRow = Required<PosPlugin>['UICustomTableBillRow'];
type Order = Parameters<UICustomTableBillRow>[0]['order'];

/**
 * A thin wrapper for the TableBillRow component,
 * which will inject custom styles in case the row is invalid
 * or has not received a vatrateID yet
 * (is still calculating)
 */
export function TaxRateValidatingBillRow({
  order,
  allowedCodes,
  children,
}: React.PropsWithChildren<{
  order: Order;
  allowedCodes: string[];
}>) {
  const loading = !order.vatrateID;
  const productID = order.vatrateID ?? '-0';
  const vatrate = useSelector(getVatRateByID(productID));
  const valid = allowedCodes.includes(vatrate?.code || 'nonexist');

  const color = (() => {
    if (loading) return styles.loadingTableRow;
    if (!valid) return styles.invalidTableRow;
    return null;
  })();

  const referencedChildren = R.adjust(
    0,
    R.evolve({
      props: { className: c => `${c} ${color ?? ''} ${styles.tableRow}` },
    }),
    React.Children.toArray(children),
  );
  return referencedChildren;
}
